import { useForm, ValidationError } from "@formspree/react";
import { Send, CheckCircle, AlertTriangle } from "lucide-react";

export default function ContactForm() {
  // --- REPLACE WITH YOUR FORM ID ---
  const YOUR_FORM_ID = "mjkprqob";
  // --------------------------------

  const [state, handleSubmit] = useForm(YOUR_FORM_ID);

  if (state.succeeded) {
    return (
      <div className="flex flex-col items-center justify-center p-8 bg-primary/10 border border-primary/20 rounded-2xl text-center h-96">
        <CheckCircle className="w-16 h-16 text-primary mb-6" />
        <h3 className="text-2xl font-bold text-text mb-2">Thank you!</h3>
        <p className="text-text-secondary">
          Your message has been sent. We'll get back to you soon.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {/* Name Field */}
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-semibold mb-2 text-text/80"
          >
            Full Name
          </label>
          <input
            id="name"
            type="text"
            name="name"
            className="w-full px-4 py-3 rounded-xl border border-border bg-input text-text shadow-sm transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary/50 placeholder:text-text/40"
            placeholder="John Doe"
            required
          />
          <ValidationError
            prefix="Name"
            field="name"
            errors={state.errors}
            className="text-primary text-sm mt-1"
          />
        </div>

        {/* Email Field */}
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-semibold mb-2 text-text/80"
          >
            Email Address
          </label>
          <input
            id="email"
            type="email"
            name="email"
            className="w-full px-4 py-3 rounded-xl border border-border bg-input text-text shadow-sm transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary/50 placeholder:text-text/40"
            placeholder="you@example.com"
            required
          />
          <ValidationError
            prefix="Email"
            field="email"
            errors={state.errors}
            className="text-primary text-sm mt-1"
          />
        </div>
      </div>

      {/* Message Field */}
      <div>
        <label
          htmlFor="message"
          className="block text-sm font-semibold mb-2 text-text/80"
        >
          Message
        </label>
        <textarea
          id="message"
          name="message"
          rows={5}
          className="w-full px-4 py-3 rounded-xl border border-border bg-input text-text shadow-sm transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary/50 placeholder:text-text/40"
          placeholder="How can we help you?"
          required
        ></textarea>
        <ValidationError
          prefix="Message"
          field="message"
          errors={state.errors}
          className="text-primary text-sm mt-1"
        />
      </div>

      {/* Submission Error (non-field-specific) */}
      {state.errors && state.errors.getFormErrors().length > 0 && (
        <div className="flex items-center gap-2 text-primary">
          <AlertTriangle className="w-5 h-5" />
          <p>Could not send message. Please try again later.</p>
        </div>
      )}

      <p className="text-xs text-text-secondary leading-relaxed">
        By submitting this form, you agree that Pilum Finance may process the
        information you provide to respond to your inquiry. Submissions are
        processed through Formspree. Please do not send private keys, seed
        phrases, passwords, or other sensitive wallet credentials. See our{" "}
        <a href="/privacy" className="text-primary hover:underline">
          Privacy Policy
        </a>
        .
      </p>

      {/* Submit Button */}
      <div>
        <button
          type="submit"
          disabled={state.submitting}
          className="relative overflow-hidden inline-flex items-center justify-center rounded-xl px-8 py-4 text-lg font-semibold transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2 bg-primary text-text shadow-lg hover:shadow-xl hover:bg-primary-hover hover:scale-105 focus:ring-primary transform border border-primary-hover group w-full sm:w-auto"
        >
          {state.submitting ? (
            "Sending..."
          ) : (
            <>
              Send Message
              <Send className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
            </>
          )}
        </button>
      </div>
    </form>
  );
}
